<template>
  <div id="mainContainer" ref="mainContainer" class="carousel-container" :style="getMainWidth">
    <div ref="tttCarousel" v-touch:swipe="swipeHandler" class="ttt-carousel" tabindex="0" @keyup="keyboardPressed">
      <div id="carousel_mask" ref="carouselMask" class="carousel-mask" :style="getMaskStyle">
        <div v-if="fadeSides || coverSides" id="leftcover" ref="leftcover" class="cover left-cover" :style="coverSize" />
        <div v-if="fadeSides || coverSides" id="rightcover" ref="rightcover" class="cover right-cover" :style="coverSize" />

        <div id="carousel_items" ref="carouselItemsHolder" class="carousel-contents" :style="getCarouselWidth">
          <div v-for="(item, index) in carouselContents" :key="`items${index}`" :ref="`divitem${index}`" tabindex="0">
            <component
              :is="dynamicComponent"
              :key="`carousel-item${index}`"
              :img-u-r-l="item.imgURL"
              :link-i-d="item.link"
              :link-type="item.linkType"
              :title="item.title"
              :description="item.description"
              :responsive="false"
              :item="item"
            />
          </div>
        </div>
      </div>

      <div v-if="showNavButtons" class="carousel-nav" :style="getMainWidth">
        <div class="left-button" :style="getNavStyles('left')" @click="slideCarousel(CAROUSEL_DIRECTION.RIGHT)">
          <img src="../../assets/img/src/icons/curved-arrow-left-circle.svg" alt="view more" class="arrow-button lazyload">
        </div>
        <div class="right-button" :style="getNavStyles('right')" @click="slideCarousel(CAROUSEL_DIRECTION.LEFT)">
          <img src="../../assets/img/src/icons/curved-arrow-left-circle.svg" alt="view more" class="arrow-button btn-right lazyload">
        </div>
      </div>

      <div v-if="showMobileNav && showMobileControls" class="carousel-mobile-controls">
        <img :src="require(`../../assets/img/src/icons/curved-arrow-left-circle.svg`)" class="mobile-controls-arrow-1 lazyload" alt="swipe for more">
        Swipe to view more
        <img :src="require(`../../assets/img/src/icons/curved-arrow-left-circle.svg`)" class="mobile-controls-arrow-2 btn-right lazyload" alt="swipe for more">
      </div>
    </div>
  </div>
</template>

<script>
import { CAROUSEL_DIRECTION } from '../../constants/constants.js';

export default {
  name: 'Carousel',
  components: {

  },
  props: {
    items: { type: Array, required: true, default: () => [] },
    itemType: { type: String, required: true, default: 'ReadMoreBlock' },
    itemsInView: { type: Number, default: 3 },
    itemSpacing: { type: Number, default: 0 },
    showNav: { type: Boolean, default: true },
    showMobileNav: { type: Boolean, default: true },
    navIconSize: { type: String, default: '40px' },
    navIconPosition: { type: String, default: '-40px' },
    bleedEdges: { type: Boolean, default: false },
    fadeItemSides: { type: Boolean, default: false },
    coverItemSides: { type: Boolean, default: false },
    coverSidesColour: { type: [String, Number], default: '#fff' },
    coverSidesOpacity: { type: Number, default: 0.8 },
    tweenTime: { type: Number, default: 1 },
  },
  data() {
    return {
      CAROUSEL_DIRECTION,
      newItems: [],
      carouselItems: [],
      positions: [],
      mappedPositions: [],
      numberOfItems: 0,
      totalItems: 0,
      posIndex: 0,
      itemWidth: 0,
      repeatStartPosition: 0,
      repeatEndPosition: 0,
      visibleItems: this.itemsInView,
      spacing: this.itemSpacing,
      fadeSides: this.fadeItemSides,
      coverSides: this.coverItemSides,
      showNavigation: this.showNav,
      showMobileControls: false,
      sdelay: 0,
    };
  },
  computed: {
    carouselContents() {
      return this.newItems;
    },
    dynamicComponent() {
      switch (this.itemType) {
        case 'VillaCard':
          const VillaCard = () => import('../VillaCard.vue');
          return VillaCard;
        case 'ReadMoreBlock':
          const ReadMoreBlock = () => import('../ReadMoreBlock.vue');
          return ReadMoreBlock;
        case 'ExperienceBlock':
          const ExperienceBlock = () => import('../ExperienceBlock.vue');
          return ExperienceBlock;
        case 'UsefulLinksBlock':
          const UsefulLinksBlock = () => import('../UsefulLinksBlock.vue');
          return UsefulLinksBlock;
        case 'Collections':
          const Collections = () => import('../cms_modules/CMSCollections.vue');
          return Collections;
        default:
      }
    },
    getMainWidth() {
      const container_width = this.visibleItems * this.itemWidth;
      // console.log('getMainWidth', container_width)

      return {
        width: this.convertNumberToPixel(container_width),
      };
    },
    getCarouselWidth() {
      const container_width = this.numberOfItems * this.itemWidth;
      // console.log('getCarouselWidth', container_width)
      return {
        width: this.convertNumberToPixel(container_width),
      };
    },
    coverSize() {
      return {
        width: '100%',
        maxWidth: this.convertNumberToPixel(this.itemWidth),
        height: '100%',
        backgroundColor: this.coverSides ? this.coverSidesColour : 'transparent',
        opacity: this.coverSidesOpacity,
      };
    },
    showNavButtons() {
      return this.showNavigation;
    },
    getMaskStyle() {
      return {
        overflow: this.bleedEdges ? 'visible' : 'hidden',
      };
    },
  },
  mounted() {
    // console.log('-----CAROUSEL MOUNTED --------');
    TweenMax.defaultOverwrite = 'all';
    this.fadeSides = this.fadeItemSides;
    this.coverSides = this.coverItemSides;
    this.visibleItems = this.itemsInView;
    this.spacing = this.itemSpacing;
    this.showNavigation = this.showNav;

    // console.log('CAROUSEL KEY =', this.$vnode.key);
    // console.log('CAROUSEL items =', this.items);
    // console.log('CAROUSEL  TYPE =', this.itemType);
    // console.log('CAROUSEL  itemsInView =', this.itemsInView);
    // console.log('CAROUSEL  props =',  this.$props);
    this.initCarousel();
  },
  beforeUpdate() {
    // console.log('-----CAROUSEL BEFORE UPDATED --------');
    TweenMax.set(this.$refs.tttCarousel, { alpha: 0 });
  },
  // watch: {
  //     items: {
  //         handler: function(n, o) {
  //             console.log('items updated to :', n, performance.now() )
  //         },
  //         immediate: true,
  //         deep: true,
  //     }
  // },
  methods: {

    // ------------------- INTI CAROUSEL  ----------------------//
    initCarousel() {
      TweenMax.set(this.$refs.carouselItemsHolder, { css: { left: 0 } });

      this.numberOfItems = this.items.length;

      this.newItems = null;
      this.newItems = this.items;
      this.newItems = this.newItems.concat(this.newItems);

      const firstItem = this.items[0];
      const lastItem = this.items[this.numberOfItems - 1];
      this.newItems.unshift(lastItem);
      this.newItems.push(firstItem);

      this.$nextTick(() => {
        this.configureCarousel();
      });
    },

    configureCarousel() {
      this.carouselItems = Array.from(this.$refs.carouselItemsHolder.children);
      this.totalItems = this.carouselItems.length;
      this.configureItemSpacing();
      TweenMax.delayedCall(1, this.setupCarousel);
      TweenMax.delayedCall(1.1, this.onScreenResize);
      window.addEventListener('resize', this.onScreenResize);
    },

    configureItemSpacing() {
      const item_spacing = Math.round(this.spacing / 2);
      this.carouselItems.forEach((element, i) => {
        element.style.paddingLeft = this.spacing !== 0 ? this.convertNumberToPixel(item_spacing) : 0;
        element.style.paddingRight = this.spacing !== 0 ? this.convertNumberToPixel(item_spacing) : 0;
      });
    },

    setupCarousel() {
      this.itemWidth = parseInt(this.carouselItems[1].offsetWidth);
      this.positions = this.getPositionsArray(0, this.itemWidth, this.totalItems);
      this.repeatEndPosition = this.positions[this.numberOfItems - 1];
      this.repeatStartPosition = this.positions[this.numberOfItems + 1];
      this.posIndex = this.numberOfItems + 1;

      // -----Create mapped X to CSS Left - Positions array to avoid reflow on animation calcs-----//
      const cbb = this.$refs.carouselItemsHolder ? this.$refs.carouselItemsHolder.getBoundingClientRect() : null;

      if (cbb) {
        const itemsPos = this.getPositionsArray(Math.round(cbb.left), -this.itemWidth, this.totalItems);
        const xl = itemsPos[this.posIndex];
        this.mappedPositions = this.getPositionsArray(xl, this.itemWidth, this.totalItems);

        TweenMax.delayedCall(0.2, this.checkCarouselItems);
        TweenMax.set(this.$refs.carouselItemsHolder, { css: { left: this.repeatStartPosition } });
        TweenMax.to(this.$refs.tttCarousel, 1, { alpha: 1, delay: 0.5 });
      }
    },

    slideCarousel(direction) {
      if (direction === CAROUSEL_DIRECTION.LEFT) {
        this.posIndex++;
        this.checkPositonIndex();
        const next_positon = this.convertNumberToPixel(this.positions[this.posIndex]);
        TweenMax.to(this.$refs.carouselItemsHolder, this.tweenTime, {
          css: { left: next_positon }, rotation: 0.001, delay: this.sdelay, onComplete: this.onSlideComplete, ease: Power4.easeOut,
        });
        // this.fadeSides ? this.checkCarouselItemsPosition(CAROUSEL_DIRECTION.LEFT) : null;
        this.fadeSides ? TweenMax.delayedCall(this.sdelay, this.checkCarouselItemsPosition, [CAROUSEL_DIRECTION.LEFT]) : null;
      }
      else if (direction === CAROUSEL_DIRECTION.RIGHT) {
        this.posIndex--;
        this.checkPositonIndex();
        const next_positon = this.convertNumberToPixel(this.positions[this.posIndex]);
        TweenMax.to(this.$refs.carouselItemsHolder, this.tweenTime, {
          css: { left: next_positon }, rotation: 0.001, delay: this.sdelay, onComplete: this.onSlideComplete, ease: Power4.easeOut,
        });
        // this.fadeSides ? this.checkCarouselItemsPosition(CAROUSEL_DIRECTION.RIGHT) : null;
        this.fadeSides ? TweenMax.delayedCall(this.sdelay, this.checkCarouselItemsPosition, [CAROUSEL_DIRECTION.RIGHT]) : null;
      }
    },

    onSlideComplete() {
      this.checkCarouselItems();
      // this.checkPositonIndex();
    },

    checkPositonIndex() {
      const maxPosIndex = this.totalItems - this.visibleItems - 1;
      const minPosIndex = 1;

      if (this.posIndex >= maxPosIndex) {
        this.sdelay = 0.2;

        this.posIndex -= this.numberOfItems;

        const pos = this.convertNumberToPixel(this.positions[this.posIndex - 1]);

        // ANGEL TRY CHANGE POSITION ANOTHER WAY MAYBE WILL WORK BETTER
        TweenMax.set(this.$refs.carouselItemsHolder, { css: { left: pos } });
        // this.$refs.carouselItemsHolder.style.left = pos;

        this.checkCarouselItems(1);
      }
      else if (this.posIndex <= minPosIndex) {
        this.sdelay = 0.2;

        this.posIndex = this.numberOfItems + 1;

        const pos = this.convertNumberToPixel(this.positions[this.posIndex + 1]);

        TweenMax.set(this.$refs.carouselItemsHolder, { css: { left: pos } });
        // this.$refs.carouselItemsHolder.style.left = pos;

        this.checkCarouselItems(-1);
      }
      else {
        this.sdelay = 0;
      }
    },

    checkCarouselItems(ex = 0) {
      // On Tween Complete setup
      if (this.fadeSides) {
        const cx = this.mappedPositions[this.posIndex + 2];
        const itemsPos = this.getPositionsArray(cx, -this.itemWidth, this.totalItems);
        const leftx = itemsPos[this.posIndex];
        const rightx = itemsPos[this.posIndex + this.visibleItems - 1];

        this.carouselItems.forEach((element, i) =>
        {
          const itemx = itemsPos[i + ex];
          // console.log('itemsPos', itemsPos)
          // console.log('itemx', itemx)

          if (this.bleedEdges && this.visibleItems <= 2) {
            if (itemx === leftx || itemx === rightx) {
              TweenMax.to(element, 0, { alpha: 1 });
            }
            else {
              TweenMax.to(element, 0, { alpha: 0.2 });
            }
          }
          else {
            if (itemx >= leftx - 1 && itemx <= rightx + 1) {
              TweenMax.to(element, 0, { alpha: 1 });
            }
            else if (itemx == leftx && itemx == rightx) {
              TweenMax.to(element, 0, { alpha: 1 });
            }
            else {
              TweenMax.to(element, 0, { alpha: 0.2 });
            }
          }
        });
      }
    },

    checkCarouselItemsPosition(direction) {
      const cx = direction === CAROUSEL_DIRECTION.LEFT ? this.mappedPositions[this.posIndex + 1] : this.mappedPositions[this.posIndex + 3];

      const itemsPos = this.getPositionsArray(cx, -this.itemWidth, this.totalItems);

      let leftx;
      let rightx;

      if (direction === CAROUSEL_DIRECTION.LEFT) {
        leftx = itemsPos[this.posIndex - 1];
        rightx = itemsPos[this.posIndex - 1 + this.visibleItems - 1];
      }
      else {
        leftx = itemsPos[this.posIndex + 1];
        rightx = itemsPos[this.posIndex + 1 + this.visibleItems - 1];
      }

      this.carouselItems.forEach((element, i) => {
        const itemx = itemsPos[i];

        if (direction === CAROUSEL_DIRECTION.LEFT) {
          if (this.bleedEdges && this.visibleItems <= 2) {
            if (itemx > leftx && itemx <= (rightx + this.itemWidth)) {
              TweenMax.to(element, 0.2, { alpha: 1 });
            }
            else {
              TweenMax.to(element, 0.2, { alpha: 0.2 });
            }
          }
          else {
            if ((itemx - this.itemWidth) > leftx - 1 && itemx < (rightx + 1 + this.itemWidth)) {
              TweenMax.to(element, 0.2, { alpha: 1 });
            }
            else {
              TweenMax.to(element, 0.2, { alpha: 0.2 });
            }
          }
        }
        else if (direction === CAROUSEL_DIRECTION.RIGHT) {
          if (this.bleedEdges && this.visibleItems <= 2) {
            if (itemx < rightx && itemx >= (leftx - this.itemWidth)) {
              TweenMax.to(element, 0.2, { alpha: 1 });
            }
            else {
              TweenMax.to(element, 0.2, { alpha: 0.2 });
            }
          }
          else {
            if ((itemx + this.itemWidth > leftx - 1) && (itemx < (rightx + 1 - this.itemWidth))) {
              TweenMax.to(element, 0.2, { alpha: 1 });
            }
            else {
              TweenMax.to(element, 0.2, { alpha: 0.2 });
            }
          }
        }
      });
    },

    // ---------------------- UTILS -------------------//
    convertNumberToPixel(val) {
      return `${val}px`;
    },

    getPositionsArray(start, increment, length) {
      return Array(length).fill(start).map((pos, i) => pos - (i * increment));
    },

    getNavStyles(direction) {
      return {
        left: direction === 'left' ? this.navIconPosition : null,
        right: direction === 'right' ? this.navIconPosition : null,
        width: this.navIconSize,
        height: this.navIconSize,
      };
    },

    showAllItems() {
      this.carouselItems.forEach((element) => {
        TweenMax.to(element, 0.2, { alpha: 1 });
      });
    },

    // -------------------------------  Screen resize  ----------------------------------------------//
    onScreenResize() {
      const margins = 80;
      const screenWidth = document.documentElement.clientWidth;
      const screenHeight = document.documentElement.clientHeight;
      const container_width = (this.itemsInView * this.itemWidth) + margins;
      const itemsCanFit = Math.floor((screenWidth - margins) / this.itemWidth);

      if (screenWidth < container_width)
      {
        itemsCanFit > 1 ? this.visibleItems = itemsCanFit : this.visibleItems = 1;

        if (itemsCanFit <= 2 && !this.bleedEdges) {
          this.fadeSides = false;
          this.coverSides = false;
        }
        else {
          this.fadeSides = this.fadeItemSides;
          this.coverSides = this.coverItemSides;
        }

        itemsCanFit === 1 && !this.bleedEdges ? this.spacing = 0 : this.spacing = this.itemSpacing;

        this.configureItemSpacing();
        this.setupCarousel();
        this.checkCarouselItems();
      }
      else {
        this.visibleItems = this.itemsInView;
        this.fadeSides = this.fadeItemSides;
        this.coverSides = this.coverItemSides;
        this.spacing = this.itemSpacing;
        this.configureItemSpacing();
        this.setupCarousel();
        this.checkCarouselItems();
      }

      // On mobiles hide the nav buttons - or we can replace them or change position, check with UX
      if (screenWidth < 1076) {
        this.showNavigation = false;
        this.showMobileControls = true;
      }
      else {
        this.showNavigation = this.showNav;
        this.showMobileControls = false;
      }
    },

    swipeHandler(direction) {
      direction === 'left' ? this.slideCarousel(CAROUSEL_DIRECTION.LEFT) : null;
      direction === 'right' ? this.slideCarousel(CAROUSEL_DIRECTION.RIGHT) : null;
    },

    keyboardPressed(e) {
      switch (e.key) {
        case 'ArrowLeft':
          this.slideCarousel(CAROUSEL_DIRECTION.RIGHT);
          break;
        case 'ArrowRight':
          this.slideCarousel(CAROUSEL_DIRECTION.LEFT);
          break;
        default:
                   // console.log('keyboard pressed not nav ', e.key);
      }
    },

  },

};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/config.scss";
$button-size: 30px;

.carousel-container{
    position: relative;
    margin:  0 auto;
}

.ttt-carousel,
.ttt-carousel:focus{
    outline: 0;

}

.carousel-mask{
    background-color:transparent;
    overflow: hidden;
}

.carousel-contents{
    position: relative;
    display: flex;
}

.cover{
    position: absolute;
    top:0px;
    width:330px;
    max-width: 330px;
    height: 400px;
    background-color:transparent;
    z-index: 50;
    opacity: 0.7;
    pointer-events: none;
}

.left-cover{
    left:0px;
}

.right-cover{
    right:0px;
}

.carousel-nav{
    position: absolute;
    top: 47%;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content:space-between;
    flex-direction: row;
}

.carousel-mobile-controls{
   position: relative;
   color: $darkBlack;
   text-align: center;
   font-size: 16px;
   font-family: $font-family-grotesk;
   margin: 10px 0 10px 0;
   display: flex;
   justify-content: center;
}

.mobile-controls-arrow-1 {
  // transform: rotate(180deg);
  margin: 0 10px 0 0;
}

.mobile-controls-arrow-2 {
  margin: 0 0 0 10px;
}

.arrow-button{
    width: $button-size;
    height:$button-size;
    cursor: pointer;
}

.btn-right{
    transform: rotate(180deg);
}

.left-button{
    position: relative;
    left: -50px;
}

.right-button{
    position: relative;
    right: -50px;
}

</style>
